import { createFeature, createReducer, on } from '@ngrx/store';

import { LanguageModel } from '../models/language.model';
import { getActualLanguage } from '../utils/get-actual-language';

import * as TranslateActions from './translate.actions';

export const TRANSLATE_FEATURE_KEY = 'translateState';

export interface TranslateState {
  languages: LanguageModel[] | null;
  actualLanguage: LanguageModel | null;
}

export const initialTranslateState: TranslateState = {
  languages: null,
  actualLanguage: null,
};

const reducer = createReducer(
  initialTranslateState,
  on(TranslateActions.setLanguages, (state, { languages }) => {
    const actualLanguage = getActualLanguage(languages);
    return { ...state, languages, actualLanguage };
  }),
  on(TranslateActions.setActualLanguage, (state, { actualLanguage }) => ({ ...state, actualLanguage })),
);

export const translateFeature = createFeature({
  name: TRANSLATE_FEATURE_KEY,
  reducer: reducer,
});
